import script from "./FileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=0ba9d57d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba9d57d"]])

export default __exports__